{
  "basis": {
    "core": "Geschützte Basis",
    "coreHint": "DMWs eigene Basiswerkzeuge, die jedes Projekt erbt. Sie ändern sich nur mit neuen DMW-Versionen; nur Administratoren öffnen sie.",
    "inherited": "Erbt die DMW-Basis",
    "inheritedHint": "Mit dem Projekt eingerichtet und mit neuen DMW-Versionen auf jede neuere DMW-Basis gebracht; die eigenen Elemente des Projekts erweitern sie.",
    "inheritedRelease": "DMW-Basis {{release}}",
    "update": "Aktualisierung verfügbar"
  },
  "chosen": "gewählt",
  "create": {
    "name": "Name",
    "next": "Danach ist es Ihr gewähltes Projekt, und seine Dokumente öffnen sich.",
    "submit": "Projekt anlegen",
    "title": "Neues Projekt"
  },
  "emptyForAdministrator": "Es gibt noch keine Projekte. Legen Sie das erste mit „Neues Projekt…“ an.",
  "emptyForMember": "Sie sind noch in keinem Projekt Mitglied. Bitten Sie die Projektadministration, Sie aufzunehmen.",
  "emptyForProjectCreator": "Sie sind noch in keinem Projekt Mitglied. Legen Sie eines mit „Neues Projekt…“ an, oder bitten Sie die Projektadministration, Sie aufzunehmen.",
  "invitation": {
    "copyLink": "Einladungslink kopieren",
    "groups": "Gruppen",
    "issued": "Einladung für {{email}}, gültig bis {{expiresAt}}. Senden Sie diesen Link selbst weiter:",
    "link": "Einladungslink",
    "shownOnce": "Der Link wird nur jetzt angezeigt. Wer ihn öffnet, kann das Konto anlegen; geben Sie ihn nur der eingeladenen Person."
  },
  "members": {
    "add": {
      "chosen": "Fügt {{name}} ({{emailHint}}) hinzu.",
      "field": "Name oder E-Mail-Adresse",
      "help": "Geben Sie einen Namen ein, um jemanden mit Konto hier zu finden, oder eine E-Mail-Adresse, um jemand Neues einzuladen.",
      "invite": "Per E-Mail einladen",
      "submit": "Hinzufügen",
      "suggestions": "Passende Konten"
    }
  },
  "menu": {
    "allProjects": "Alle Projekte…",
    "choose": "Projekt wählen",
    "issues": "Issues",
    "label": "Projekt",
    "newProject": "Neues Projekt…",
    "settings": "Einstellungen",
    "settingsOf": "Einstellungen von {{project}}",
    "switch": "Wechseln zu"
  },
  "needed": {"action": "Zu den Projekten", "title": "Wählen Sie zuerst ein Projekt"},
  "picker": {"choose": "Projekt wählen…", "label": "Projekt"},
  "settings": {
    "danger": {
      "confirm": "Projekt löschen",
      "confirmMessage_one": "Das Projekt verschwindet aus allen Listen, und niemand kann es mehr öffnen, auch seine eigenen Administratorinnen und Administratoren nicht. {{count}} Tag lang kann eine Administratorin oder ein Administrator es so wiederherstellen, wie es war.",
      "confirmMessage_other": "Das Projekt verschwindet aus allen Listen, und niemand kann es mehr öffnen, auch seine eigenen Administratorinnen und Administratoren nicht. {{count}} Tage lang kann eine Administratorin oder ein Administrator es so wiederherstellen, wie es war.",
      "confirmTitle": "{{project}} löschen?",
      "delete": "Dieses Projekt löschen",
      "deleteHint_one": "Es verschwindet für alle. Administratorinnen und Administratoren können es {{count}} Tag lang wiederherstellen und danach endgültig löschen.",
      "deleteHint_other": "Es verschwindet für alle. Administratorinnen und Administratoren können es {{count}} Tage lang wiederherstellen und danach endgültig löschen.",
      "title": "Gefahrenbereich"
    },
    "export": {
      "gitBundle": "Git-Bundle",
      "hint": "Laden Sie herunter, was dieses Projekt veröffentlicht, oder das ganze Projekt. Datenveröffentlichungen entstehen hier oder auf der Seite Datenmodell.",
      "latestRelease": "Neueste Datenveröffentlichung",
      "title": "Herunterladen",
      "wholeProject": "Das ganze Projekt"
    },
    "members": {"person": "Person", "throughGroup": "über {{group}}"},
    "name": "Projektname",
    "rules": {
      "fromDefaults": "Vorgaben der Installation beim Anlegen des Projekts ({{at}}): {{rules}}",
      "history": "Regelverlauf",
      "installationMergesSystemChangesHint": "Wenn eine DMW-Version Projekte auf eine neue Prozessontologie umstellt, übernimmt DMW diese Änderung selbst. Aus: Die Änderung wartet auf die Kuratierenden dieses Projekts, und hier startet kein Durchlauf, bis sie sie übernommen haben.",
      "lastChange": "{{rule}}: geändert von {{name}}, {{at}}: „{{reason}}“",
      "names": {
        "installation_merges_system_changes": "DMW übernimmt seine eigenen Systemänderungen",
        "merge_rules": "Wer die eigene Änderung übernehmen darf",
        "new_member_role": "Standardgruppe beim Hinzufügen",
        "personal_skills_in_shared_threads": "Persönliche Skills in geteilten Durchläufen",
        "pinning_projects": "Projekte, die diese Bibliothek festlegen dürfen",
        "publish_to_researchspace": "Datenveröffentlichungen in ResearchSpace veröffentlichen",
        "release_roles": "Wer Datenveröffentlichungen erstellen darf",
        "server_key_groups": "Wer die API-Schlüssel des Servers nutzen darf"
      },
      "otherAuthors": "Andere Autorinnen und Autoren",
      "pinningProjectOther": "Nicht verfügbares Projekt",
      "pinningProjectsDefaultsHint": "An: Ein neues Projekt beginnt mit einer leeren Liste. Niemand kann es als Bibliothek festlegen, bis seine Administration Projekte aufführt.",
      "pinningProjectsHint": "Aus: Wer diese Bibliothek lesen kann, darf sie in jedem Projekt festlegen, in dem er oder sie Änderungen vorschlagen darf. An: Nur die hier aufgeführten Projekte dürfen einen Pin hinzufügen oder auf eine andere Version setzen. Bestehende Pins behalten ihre Version und funktionieren weiter.",
      "pinningProjectsOnly": "Nur die hier aufgeführten Projekte dürfen dieses Projekt als Bibliothek festlegen",
      "publishToResearchSpaceHint": "Datenveröffentlichungen lassen sich dann im ResearchSpace der Installation veröffentlichen, wo das Projekt eigene Graphen und Seiten bekommt. Ausschalten nimmt die Seiten des Projekts heraus; seine veröffentlichten Graphen bleiben. Gilt, sobald die Administration ResearchSpace verbunden hat.",
      "secondCurator": "Werkzeuge und Skills mit Code brauchen eine zweite Freigabe",
      "title": "Regeln"
    },
    "secondCurator": {
      "allowed": "Nie",
      "never": "Immer",
      "only_when_alone": "Sobald das Projekt weitere Mitglieder hat",
      "only_without_other_curator": "Wenn sonst jemand sie kuratiert"
    },
    "tabs": {
      "access": "Zugriff",
      "general": "Allgemein",
      "history": "Historie",
      "label": "Projekteinstellungen",
      "rules": "Regeln"
    },
    "title": "Einstellungen von {{project}}"
  },
  "title": "Projekte"
}
